import React from 'react';

interface States {
}

interface Props {
    title: String;
}

class Title extends React.Component<Props, States> {

    state: States

    constructor(props: Props) {
        super(props)
        this.state = {}

    }

    render() {
        return (
            <div>
                <h1
                    className="title">
                    {this.props.title}
                </h1>
            </div>
        )
    }
}

export default Title;
